import { observable, action, computed, when } from 'mobx';
import * as filestack from 'filestack-js';
import axios from "axios";
import { toast } from "react-toastify"
import IDocument, {  IDocumentSecurityType, IDocumentFilter, IDocumentCollection, newDocInstance, validateDoc, isDocValid, newFileInstance, newDocFilterInstance } from '../types/IDocument';
import ICategory from "../types/ICategory";
import IList, { IListItem } from "../types/IList";
import ILookup from '../types/ILookup';
import IDocumentService from '../services/spi/IDocumentService';
import ICategoryService from "../services/spi/ICategoryService";
import IListService from "../services/spi/IListService";
import ITemplateService from '../services/spi/ITemplateService';
import ISettingsService from '../services/spi/ISettingsService';
import FirebaseSettingsService from '../services/impl/firebase/FirebaseSettingService';
import FirebaseDocumentService from '../services/impl/firebase/FirebaseDocumentService';
import FirebaseCategoryService from "../services/impl/firebase/FirebaseCategoryService";
import FirebaseListService from "../services/impl/firebase/FirebaseListService";
import FirebaseTemplateService from '../services/impl/firebase/FireBaseTemplateService';
import IDocumentStorageService from '../services/spi/IDocumentStorageService';
// import FileStackStorageService from '../services/impl/filestack/FileStackStorageService';
import GcpStorageService from '../services/impl/storageServices/GcpStorageService';
import ITrackingService from '../services/spi/ITrackingService';
import FirebaseTrackingService from '../services/impl/firebase/FirebaseTrackingService';
import { ITrackingEventCategory, ITrackingEventName } from '../types/ITrackingEvent';
import FirebaseActivityService from '../services/impl/firebase/FirebaseActivityService';
import IActivityService from '../services/spi/IActivityService';
import { IActivityActor, IActivityContent, IActivityCollection } from '../types/IActivity';
import ICustomerService from '../services/spi/ICustomerService';
import ICustomer, { ICustomerCollection, newCustFilterInstance } from '../types/ICustomer';
import FirebaseCustomerService from '../services/impl/firebase/FirebaseCustomerService';

import whatsapp_logo from '../assets/img/inviteIcons/whatsapp_logo.png';
import skype_logo from'../assets/img/inviteIcons/skype_logo.png';
import viber_logo from'../assets/img/inviteIcons/viber_logo.png';
import wechat_logo from'../assets/img/inviteIcons/wechat_logo.png';
import messenger_logo from '../assets/img/inviteIcons/messenger_logo.png';
import IPaginator, { IPaginatorQueryType, IFirebasePaginatorOperation, newPaginatorInstance } from '../types/Paginator';
import ITemplate from '../types/ITemplate';

class LibraryStore {
    rootStore:any = null;
    client:any = null;
    destination_file_name: any = "";
    @observable fileObject:any = null;
    
    documentService = {} as IDocumentService;
    customerService = {} as ICustomerService;
    categoryService = {} as ICategoryService;
    listService = {} as IListService;
    templateService = {} as ITemplateService;
    storageService = {} as IDocumentStorageService;
    lookupService = {} as ISettingsService;
    trackingService = {} as ITrackingService;
    activityService = {} as IActivityService;

    @observable screen = {
      list: {
        isLoading: false
      },
      create: {
        isUploading: false,
        uploadingPercent: 20,
        isSaving: false,
        fileSelected: false
      },
      edit: {
        isLoading: false,
        isUploading: false,
        uploadingPercent: 20,
        isSaving: false,
        fileSelected: false
      },
      editMode: false,
      createMode: false,
      shareMode: false,
      detailMode: false
    }

    @observable documentCollection:IDocumentCollection = {
      documents: [],
      paginator: newPaginatorInstance()
    };
    @observable documentFilter = {} as IDocumentFilter;
    @observable documentPaginator = {} as IPaginator;
    
    @observable activityCollection: IActivityCollection = {
      activities: [],
      paginator: newPaginatorInstance()
    }

    @observable docCategoryList = [] as Array<ICategory>;
    @observable contentTypeList = [] as Array<IListItem>;
    @observable customerStageList = [] as Array<IListItem>;
    @observable templateList = [] as Array<ITemplate>

    @observable customers = [] as Array<ICustomer>;
    @observable customer = {} as ICustomer;
    

    @observable document: IDocument = newDocInstance();
    @observable errors: any = {};
    
    @observable sharingIcons:any = {
      currentIcon: {},
      icons: [
        { name: 'whatsapp', img : whatsapp_logo, selected: false},
        { name: 'skype', img: skype_logo, selected: false},
        { name: 'viber', img: viber_logo, selected: false},
        { name: 'wechat', img: wechat_logo, selected: false},
        { name: 'messenger', img: messenger_logo, selected: false}
      ]
    };
    @observable itemsPerPage: number = 2;
    @observable shareableLink:string = "";

  constructor(rootStore:any) {
    this.rootStore = rootStore;
    this.documentService = new FirebaseDocumentService();
    this.categoryService = new FirebaseCategoryService();
    this.listService = new FirebaseListService();
    this.templateService = new FirebaseTemplateService();
    this.activityService = new FirebaseActivityService();
    // this.storageService = FileStackStorageService.getInstance();
    this.storageService = GcpStorageService.getInstance();
    this.lookupService = new FirebaseSettingsService();
    this.trackingService = new FirebaseTrackingService();
    this.customerService = new FirebaseCustomerService();

    this.documentPaginator = newPaginatorInstance();
    this.documentFilter = newDocFilterInstance();
  }

  @action setDocumentFilter(filter?:IDocumentFilter, added?:boolean){
   this.documentFilter = {...this.documentFilter, ...filter};
   this.documentPaginator = newPaginatorInstance();
  }

  @action setPaginator(paginator:IPaginator){
    this.documentPaginator = Object.assign(this.documentPaginator, paginator);
  }

  @action loadDocuments = async () => {
      try{
        this.screen.list.isLoading = true; 
        this.documentCollection = await this.documentService.getDocuments(this.documentPaginator, this.documentFilter);
        this.documentPaginator = this.documentCollection.paginator;
        this.screen.list.isLoading = false;
        this.trackingService.track(ITrackingEventCategory.DOCUMENT, ITrackingEventName.CONTENT_PAGE_ACCESSED, {});
      }catch(e){
        this.screen.list.isLoading = false;
        toast.error("Error loading documents. ");
      }
  }

  @action loadSideBarFilterData = async () => {
    try{
      this.docCategoryList = await this.categoryService.getCategories();
      const contentType:IList = await this.listService.getList("CONTENT_TYPE");
      this.contentTypeList = contentType && contentType.options ? contentType.options : [];
      const customerStageType:IList = await this.listService.getList("CUSTOMER_STAGE");
      this.customerStageList = customerStageType && customerStageType.options ? customerStageType.options: [];
      this.templateList = await this.templateService.getTemplates('', 10, 0);
    }catch(e){
      toast.error("Couldnot load filter data");
    }
  }

  @action changeScreenState = (obj:any) => {
    this.screen = {...this.screen, ...obj};
    this.errors = {};
  }

  @action createNewRow = (doc: IDocument) => {
      this.document = newDocInstance();
  }

  @action loadDocumentForEdit = async (uid:string) => {
    try{
      this.screen.edit.isLoading = true;
      this.document = await this.documentService.getDocument(uid);
      this.screen.edit.isLoading = false;
      this.activityCollection = await this.documentService.getDocumentActivities(uid, newPaginatorInstance());
    }catch(e){
      this.screen.edit.isLoading = false;
      toast.error('Error Loading Document');
      this.changeScreenState({
        editMode: false
      })
    }
    
  }

  @action setDocument = (doc:IDocument) => {
      this.document = doc;
  }

  @action setAttribute =  async(fieldsToUpdate:Partial<IDocument>) =>{
    this.document = {...this.document, ...fieldsToUpdate};
    this.revalidateDocument();
  }

  @action
  setCustomer = (customer:ICustomer)=>{
    this.customer = customer;
  }

  @action
  loadCustomers = async () => {
    const custCollection: ICustomerCollection = await this.customerService.getCustomers(newPaginatorInstance(), newCustFilterInstance());
    this.customers = custCollection.customers;
  }

  @action setFileAttribute = (data: any) => {
    this.fileObject = data.file;
    this.document.file.fileName = data.file.name;
    this.document.file.mimeType = data.file.type;
    this.document.file.size = data.file.size;
    this.document.file.extension = data.file.type;
    this.document.file.noOfPages = data.pages;
    this.document.file.thumbPageNo = data.thumbPageNo
    this.document.file.extension = 'pdf';

    this.screen.create.fileSelected = true;

    this.revalidateDocument();
  }

  @action removeSelectedFile = () => {
    this.document = Object.assign(this.document, newFileInstance());
  }

  @action addTag = (tag: string) => {
    this.document.tags.push(tag);
  }

  @action removeTag = (pos:number) => {
    delete this.document.tags[pos];
  }

   _uploadDocument = async (success:any) => {
    // this.isUploading = true;
    try{
        const metadata = { refId : this.document.uid}
        await this.storageService.uploadDocument(this.fileObject, metadata, this.document, (snapshot)=>{
          const progress = (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
          this.destination_file_name = snapshot.ref.name;
          this.screen.create.isUploading = true;
          this.screen.create.uploadingPercent = progress;
          console.log('Upload is ' + progress + '% done');
          switch (snapshot.state) {
            case 'paused':
              console.log('Upload is paused');
              break;
            case 'running':
              console.log('Upload is running');
              break;
            case 'success':

              break;
            }
        }, (doc:IDocument)=>{
          doc.file.conversionStatus = "PENDING";
          this.screen.create.isUploading = false;
          success(doc);
        }, (err:any)=>{
          toast.error(err);
          this.screen.create.isUploading = false;
        },);
    }catch(e){
      toast.error("Error Uploading document");
    }
  }

  @action revalidateDocument = async () => {
    this.errors = await validateDoc(this.document);
  }

  @action saveDocument = async () => {
    const { uid, ...documentSnapshot } = this.document;
    try{
      if(await isDocValid(this.document)){//if it has docUrl
        if(uid == undefined || uid == ""){
            this._uploadDocument(async (doc:IDocument)=>{
              this.document = Object.assign(this.document, doc);
              this.document = await this.documentService.createDocument(this.document);
              let object = {
                message: {
                  documentUid: this.document.uid,
                  fileName: this.destination_file_name
                }
              }
              await this.documentService.pushToQueue(object);
              toast.success("Document Saved!!");
              this.changeScreenState({
                editMode: false,
                createMode: false
              })
            });
          } else {
            await this.documentService.updateDocument(this.document);
            toast.success("Document Updated");
            this.changeScreenState({
              editMode: false,
              createMode: false
            })
          }
          this.loadDocuments();
        } else {
          this.revalidateDocument();
      }
    }catch(e){
      console.log(e)
      toast.error("Error Saving Document");
    }
  }

  @action removeDocument = async () => {
    const { uid } = this.document;
    try {
      if (uid) {
        await this.documentService.deleteDocument(uid);
        this.loadDocuments()
        toast.success("Document Deleted!!");
      } 
    } catch (e) {
      console.log(e)
      toast.error("Failed To Delete");
    }
  }

  @action createShareableLink = async (customerName: string, cusUid: string) => {
    let templateContent = ""
    if (this.document.coverTemplate) {
      const q = await this.templateService.getTemplate(this.document.coverTemplate);
      templateContent = q.content;
    }

    let shareObj = {
      documentUid: this.document.uid,
      customerUid: cusUid,
      userUid: this.document.who.owner.uid,
      content: templateContent,
      createdAt: new Date().getTime(),
      type: 'content'
    }
    const shareCode = await this.documentService.createShareableLink(shareObj);
    this.shareableLink = `https://asia-east2-og-ordertest.cloudfunctions.net/content/${shareCode}`;
  }

  @action shareDocument = async (shareVia:any, authUser: any ) => {
    let shareObject:any = {
      user: authUser,
      document: this.document,
      customer: this.customer,
      redirectUrl: this.shareableLink
    };
    //this.sharing = true;

    for (let mode of shareVia ) {
      let searchCode = mode == "email" ? "de" : "ds";
      let temp = await this.templateService.getTemplateByCode(searchCode);
      shareObject[mode+"Template"] = temp.content;
      shareObject[mode] = true;
    }

    try{ 
      const res = await this.documentService.shareDocument(shareObject);
      console.log(res);
      //this.sharing = false;
      toast.success('Content Shared!!')
      if (res.status == 200){
        toast.success('Meeting Shared!!')
      }
    }
    catch(e){
      throw e
    }
  }


  /*@computed get documentList() {
    return Object.keys(this.documents || {}).map(key => ({
      ...this.documents[key],
      uid: key,
    }));
  }*/
}

export default LibraryStore;